export default __webpack_public_path__ + "static/important-car-loan-eeef99aaa3e63a6f614d8bee924e9816.webp";